type TranslationDictionary = Record<string, string>;

const translationModules = import.meta.glob('../locales/*/translation.json');

export async function loadTranslations(locale: string): Promise<TranslationDictionary | null> {
    const modulePath = `../locales/${locale}/translation.json`;
    const loader = translationModules[modulePath];

    if (!loader) {
        return null;
    }

    const module = (await loader()) as { default: TranslationDictionary };
    return module.default;
}
